import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { WMS2090_R01DetailDto, WMS2090_R01Dto, WMS2090_R01HeaderDto } from "./Dto_WMS2090_R01";
import { WMS2090_R01Filter } from "./Store_WMS2090_R01";


const baseUrl = `${config.apiUrl}/WMS2090_R01`;

const getParams = (filter: Partial<WMS2090_R01Filter>, listLength?: number) => {	
	return {
		transportNo: filter.transportNo || undefined,
		customCd: filter.customCd || undefined,	
		customNm: filter.customNm || undefined,

		listLength: listLength || 0
	}
}

export const getWMS2090_R01List = async (option: string, params: Partial<WMS2090_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<WMS2090_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getWMS2090_R01AllCount = async (params: Partial<WMS2090_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getWMS2090_R01One = async (transportNo: string) => {
	const url = `${baseUrl}/one/${transportNo}`;

	return await getData<ResponseDto<WMS2090_R01HeaderDto>>(url);
}

export const getWMS2090_R01DetailList = async (transportNo: string, warehouseCd: string) => {
	const url = `${baseUrl}/detail/${transportNo}/${warehouseCd}`;

	return await getData<ResponseDto<WMS2090_R01DetailDto[]>>(url);
}

export const createWMS2090_R01LotNo = async () => {
	const url = `${baseUrl}/lot/createLotNo`;
	return await getData<ResponseDto<string>>(url);
}

export const postWMS2090_R01 = async (data: WMS2090_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<WMS2090_R01Dto, ResponseDto<WMS2090_R01Dto>>(url, data);
}

export const patchWMS2090_R01 = async (data: WMS2090_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<WMS2090_R01Dto, ResponseDto<WMS2090_R01Dto>>(url, data);
}

export const deleteWMS2090_R01 = async (transportNo: string, warehouseCd: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			transportNo,
			warehouseCd
		}
	});
}

export const downloadExcel_WMS2090_R01 = async (option: string, transportNo: string, warehouseCd: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			transportNo,
			warehouseCd
		}
	})
}

